<template>
    <tr class="time-row">
        <td>
            <time-range-picker
                :start="formattedStartTime"
                :end="formattedEndTime"
                @change="onChangeTimeRange($event)"
                @errorStateChanged="timeRangeHasError = $event"
            />
        </td>

        <td>
            <icon-save
                :disabled="!canBeSaved || !isEditable"
                @click="onUpdate()"
            />

            <icon-reset
                :disabled="pending || !isEditable"
                @click="$emit('cancel')"
            />

            <icon-delete
                :disabled="pending || !isDeletable"
                @click="onDelete()"
            />
        </td>
    </tr>
</template>

<script>
import IconDelete from '../../common/icon/IconDelete';
import IconReset from '../../common/icon/IconReset';
import IconSave from '../../common/icon/IconSave';
import TimeRangePicker from '../../common/form/picker/TimeRangePicker';
import moment from 'moment';

export default {
    name: 'KgrMemberAttendanceTimeEditRow',
    components: {IconReset, IconDelete, IconSave, TimeRangePicker},
    props: {
        attendanceId: {
            type: String,
            required: true,
        },
        start: {
            type: String,
            required: true,
        },
        end: {
            type: String,
            required: false,
        },
        pendingAttendances: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            momentStart: null,
            momentEnd: null,
            timeRangeHasError: false,
        };
    },
    computed: {
        formattedStartTime() {
            return this.momentStart.format('HH:mm');
        },
        formattedStartDateTime() {
            return this.momentStart.format('YYYY-MM-DD HH:mm:ss');
        },
        formattedEndTime() {
            return this.momentEnd.format('HH:mm');
        },
        formattedEndDateTime() {
            return this.momentEnd.format('YYYY-MM-DD HH:mm:ss');
        },
        pending() {
            return this.pendingAttendances.includes(this.attendanceId);
        },
        canBeSaved() {
            return !this.pending && !this.timeRangeHasError;
        },
    },
    created() {
        this.momentStart = moment(this.start);
        this.momentEnd = this.end ? moment(this.end) : moment(this.start);
    },
    methods: {
        onUpdate() {
            this.$emit('attendanceUpdated', {start: this.formattedStartDateTime, end: this.formattedEndDateTime});
        },
        onDelete() {
            showConfirm(this.$t('confirmInformal'), this.$t('Soll die Anwesenheit wirklich entfernt werden?'), () => {
                this.$emit('attendanceRemoved');
            });
        },
        onChangeTimeRange(timeRange) {
            this.momentStart = moment(this.momentStart).set('hour', timeRange.start.hours).set('minute', timeRange.start.minutes);
            this.momentEnd = moment(this.momentEnd).set('hour', timeRange.end.hours).set('minute', timeRange.end.minutes);
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .time-row {
        line-height: 34px;
        vertical-align: top;
    }
</style>
